// Build a download filename of the form "<base>_<YYYY-MM-DD_HHMM>.<ext>".
//
// Exports used to save as flat names like "audit-5.xlsx" or "assets.xlsx",
// so re-downloading overwrote the previous file and there was no record of
// WHEN a report was generated. This stamps every export with a meaningful
// base name + the download timestamp. The base is sanitised so an audit
// name like "Audit · EPGC · 6/20/2026" becomes a safe filename segment.

export function tsFilename(base, ext) {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  const stamp = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}`;
  const safe = String(base || 'export')
    .trim()
    .replace(/[^\w.-]+/g, '_')  // anything not a word char / dot / dash → underscore
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 80) || 'export';
  return `${safe}_${stamp}.${ext}`;
}
